package com.merkost.handpass.api.dto.waitlist

import kotlinx.serialization.Serializable

@Serializable
data class WaitlistCountResponse(
    val count: Long,
)
